document.addEventListener('DOMContentLoaded',function(){
  const finder=document.querySelector('#sayora-finder');
  if(!finder) return;

  const answers={};
  let step=1;
  const steps=[...finder.querySelectorAll('.finder-step')];
  const results=document.querySelector('#finder-results');
  const resultItems=[...finder.parentElement.querySelectorAll('.finder-result-item')];
  const progress=finder.querySelector('[data-finder-progress]');
  const stepLabel=finder.querySelector('[data-finder-step-label]');
  const summary=document.querySelector('[data-finder-summary]');
  const noMatch=document.querySelector('[data-finder-no-match]');
  const prev=finder.querySelector('#finder-prev');
  const next=finder.querySelector('#finder-next');
  const nav=finder.querySelector('.finder-nav');
  const restart=document.querySelector('#finder-restart');
  const detailGroups=[...finder.querySelectorAll('.finder-secondary-group')];
  const totalSteps=steps.length;

  const normalize=(value)=>String(value||'')
    .replace(/[’‘]/g,"'")
    .replace(/[–—]/g,'-')
    .replace(/\s*\/\s*/g,' / ')
    .replace(/\s+/g,' ')
    .trim().toLowerCase();
  const tokens=(value)=>normalize(value).split(/[|,]/).map(v=>v.trim()).filter(Boolean);
  const field=(item,key)=>normalize(item.dataset[key]||'');
  const allFieldValues=(item,key)=>tokens(item.dataset[key]||'');
  const aliases={
    'new beginning':['new job','new home','new chapter','graduation','starting over','promotion'],
    'encouragement':['growth','hope','good fortune'],
    'thank you moment':['gratitude'],
    'long distance':['long-distance'],
    'myself':['myself','yourself']
  };
  const matches=(item,wanted,keyList)=>{
    const target=normalize(wanted);
    if(!target) return false;
    const values=[];
    (keyList||[]).forEach(k=>values.push(...allFieldValues(item,k)));
    values.push(...tokens(item.dataset.productTags||''));
    const testSet=new Set(values);
    if(testSet.has(target)) return true;
    if((aliases[target]||[]).some(v=>testSet.has(v))) return true;
    return [...testSet].some(v=>v.includes(target)||target.includes(v));
  };
  const budgetRange=(value)=>{
    const n=normalize(value).replace(/\$/g,'').replace(/[–—]/g,'-').replace(/\s/g,'');
    if(n==='40-60') return {min:40,max:60};
    if(n==='60-80') return {min:60,max:80};
    if(n==='80-120') return {min:80,max:120};
    if(n==='120+') return {min:120,max:Infinity};
    return null;
  };
  const priceInBudget=(item)=>{
    const range=budgetRange(answers.budget);
    if(!range) return true;
    const price=Number(item.dataset.productPrice||0)/100;
    return Number.isFinite(price)&&price>=range.min&&price<=range.max;
  };
  const scoreProduct=(item)=>{
    let score=0;
    if(matches(item,answers.relationship_detail,['productRelationshipDetail','productGiftFor'])) score+=40;
    if(matches(item,answers.relationship,['productRelationship','productGiftFor'])) score+=30;
    if(matches(item,answers.occasion,['productOccasion','productGiftWhen'])) score+=35;
    if(matches(item,answers.meaning,['productMeaning','productTags'])) score+=25;
    return score;
  };
  const show=()=>{
    steps.forEach((s,i)=>s.classList.toggle('active',i===step-1));
    if(prev) prev.style.visibility=step===1?'hidden':'visible';
    if(progress) progress.style.width=((step/totalSteps)*100)+'%';
    if(stepLabel) stepLabel.textContent=step+' / '+totalSteps;
    if(nav) nav.style.display='flex';
    if(next) next.textContent=step===totalSteps?'Show Gifts':'Next';
  };
  const canAdvance=()=>step===5||((step===1&&answers.relationship)||(step===2&&answers.relationship_detail)||(step===3&&answers.occasion)||(step===4&&answers.meaning));
  const renderResults=()=>{
    const pool=resultItems.filter(priceInBudget);
    const ranked=pool.map(item=>({item,score:scoreProduct(item)})).sort((a,b)=>b.score-a.score || Number(a.item.dataset.productPrice||0)-Number(b.item.dataset.productPrice||0));
    const positive=ranked.filter(x=>x.score>0);
    const list=(positive.length?positive:ranked).slice(0,8);
    resultItems.forEach(item=>{item.style.display='none';});
    list.forEach((entry)=>{
      entry.item.style.display='block';
      const badge=entry.item.querySelector('[data-match-badge]');
      if(badge){badge.textContent=entry.score>=90?'Strong Match':entry.score>=50?'Good Match':'Thoughtful Alternative';}
    });
    if(noMatch){
      if(!pool.length) noMatch.textContent='We couldn’t find a gift in that price range. Try a wider budget, or skip budget to explore more gifts.';
      else if(!positive.length) noMatch.textContent='We found close alternatives based on your budget. Try changing one answer for a different direction.';
      noMatch.style.display=(!pool.length||!positive.length)?'block':'none';
    }
    const recipient=answers.relationship_detail||answers.relationship||'someone special';
    const moment=answers.occasion||'any moment';
    const feeling=answers.meaning||'a meaningful message';
    if(summary) summary.textContent='For '+recipient+' · '+moment+' · '+feeling+(answers.budget?' · '+answers.budget:'')+'.';
    if(results) results.style.display='block';
    if(nav) nav.style.display='none';
    steps.forEach(s=>s.classList.remove('active'));
    try{localStorage.setItem('sayoraFinderAnswers',JSON.stringify(answers));}catch(e){}
    if(results&&typeof results.scrollIntoView==='function') results.scrollIntoView({behavior:'smooth',block:'start'});
  };
  const goNext=()=>{
    if(step===5&&canAdvance()){renderResults();return;}
    if(!canAdvance()){
      const active=steps[step-1];
      if(active){active.classList.add('finder-validation-shake');setTimeout(()=>active.classList.remove('finder-validation-shake'),350);}
      return;
    }
    step=Math.min(totalSteps,step+1); show();
  };

  finder.querySelectorAll('.finder-choice[data-key="relationship"]').forEach(btn=>btn.addEventListener('click',()=>{
    answers.relationship=btn.dataset.value; delete answers.relationship_detail;
    finder.querySelectorAll('[data-key="relationship"]').forEach(x=>x.classList.remove('selected')); btn.classList.add('selected');
    detailGroups.forEach(group=>group.classList.toggle('active',group.dataset.parent===btn.dataset.value));
    finder.querySelectorAll('.finder-secondary-choice').forEach(x=>x.classList.remove('selected'));
    setTimeout(()=>{step=2;show();},140);
  }));
  finder.querySelectorAll('.finder-secondary-choice').forEach(btn=>btn.addEventListener('click',()=>{
    answers.relationship_detail=btn.dataset.value;
    finder.querySelectorAll('.finder-secondary-choice').forEach(x=>x.classList.remove('selected')); btn.classList.add('selected');
    setTimeout(()=>{step=3;show();},140);
  }));
  finder.querySelectorAll('.finder-choice[data-key="occasion"]').forEach(btn=>btn.addEventListener('click',()=>{
    answers.occasion=btn.dataset.value;
    finder.querySelectorAll('[data-key="occasion"]').forEach(x=>x.classList.remove('selected')); btn.classList.add('selected');
    setTimeout(()=>{step=4;show();},140);
  }));
  finder.querySelectorAll('.finder-choice[data-key="meaning"]').forEach(btn=>btn.addEventListener('click',()=>{
    answers.meaning=btn.dataset.value;
    finder.querySelectorAll('[data-key="meaning"]').forEach(x=>x.classList.remove('selected')); btn.classList.add('selected');
    setTimeout(()=>{step=5;show();},140);
  }));
  finder.querySelectorAll('.finder-choice[data-key="budget"]').forEach(btn=>btn.addEventListener('click',()=>{
    answers.budget=btn.dataset.value;
    finder.querySelectorAll('[data-key="budget"]').forEach(x=>x.classList.remove('selected')); btn.classList.add('selected');
  }));
  const skipBudget=finder.querySelector('[data-skip-budget]');
  if(skipBudget) skipBudget.addEventListener('click',()=>{delete answers.budget; renderResults();});
  if(next) next.addEventListener('click',goNext);
  if(prev) prev.addEventListener('click',()=>{if(step>1){step--;show();}});
  if(restart) restart.addEventListener('click',()=>{Object.keys(answers).forEach(k=>delete answers[k]);step=1;resultItems.forEach(i=>i.style.display='block');finder.querySelectorAll('.finder-choice').forEach(x=>x.classList.remove('selected'));detailGroups.forEach(x=>x.classList.remove('active'));if(results)results.style.display='none';if(noMatch)noMatch.style.display='none';show();finder.scrollIntoView({behavior:'smooth',block:'start'});});

  show();
});

document.addEventListener('DOMContentLoaded',function(){
  const gallery=document.querySelector('[data-product-gallery]');
  if(!gallery) return;

  const mainButton=gallery.querySelector('[data-product-lightbox-open]');
  const mainImage=mainButton ? mainButton.querySelector('img') : null;
  const thumbs=[...gallery.querySelectorAll('[data-product-thumbnail]')];
  const galleryPrev=gallery.querySelector('[data-product-gallery-prev]');
  const galleryNext=gallery.querySelector('[data-product-gallery-next]');
  const lightbox=document.querySelector('[data-product-lightbox]');
  const lightboxImage=lightbox ? lightbox.querySelector('[data-product-lightbox-image]') : null;
  const lightboxPrev=lightbox ? lightbox.querySelector('[data-product-lightbox-prev]') : null;
  const lightboxNext=lightbox ? lightbox.querySelector('[data-product-lightbox-next]') : null;
  if(!mainImage) return;

  let currentIndex=Math.max(0,thumbs.findIndex(t=>t.classList.contains('is-active')));

  // Shopify's image_tag adds srcset. If only `src` changes, the browser may
  // continue rendering the old srcset candidate, so clear responsive sources
  // before switching to the selected gallery image.
  const setImageByIndex=(index,{scrollThumb=true}={})=>{
    if(!thumbs.length) return;
    currentIndex=(index+thumbs.length)%thumbs.length;
    const thumb=thumbs[currentIndex];
    const url=thumb.dataset.imageUrl;
    const lightboxUrl=thumb.dataset.lightboxUrl||url;
    const alt=thumb.dataset.imageAlt||mainImage.alt;
    if(!url) return;

    mainImage.removeAttribute('srcset');
    mainImage.removeAttribute('sizes');
    mainImage.src=url;
    mainImage.alt=alt;

    if(lightboxImage){
      lightboxImage.removeAttribute('srcset');
      lightboxImage.removeAttribute('sizes');
      lightboxImage.src=lightboxUrl;
      lightboxImage.alt=alt;
    }

    thumbs.forEach((t,i)=>t.classList.toggle('is-active',i===currentIndex));
    if(scrollThumb && thumb && typeof thumb.scrollIntoView==='function'){
      thumb.scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'});
    }
  };

  const showPrevious=()=>setImageByIndex(currentIndex-1);
  const showNext=()=>setImageByIndex(currentIndex+1);

  thumbs.forEach((t,index)=>t.addEventListener('click',e=>{
    e.preventDefault();
    setImageByIndex(index,{scrollThumb:false});
  }));

  if(galleryPrev) galleryPrev.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();showPrevious();});
  if(galleryNext) galleryNext.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();showNext();});

  const open=()=>{
    if(!lightbox) return;
    // Ensure the full-screen viewer opens on the image currently shown above.
    if(thumbs.length) setImageByIndex(currentIndex,{scrollThumb:false});
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden','false');
    document.body.classList.add('lightbox-open');
  };
  const close=()=>{
    if(!lightbox) return;
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden','true');
    document.body.classList.remove('lightbox-open');
  };

  mainButton.addEventListener('click',open);

  if(lightbox){
    lightbox.querySelectorAll('[data-product-lightbox-close]').forEach(x=>x.addEventListener('click',close));
    if(lightboxPrev) lightboxPrev.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();showPrevious();});
    if(lightboxNext) lightboxNext.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();showNext();});

    document.addEventListener('keydown',e=>{
      if(!lightbox.classList.contains('is-open')) return;
      if(e.key==='Escape') close();
      if(e.key==='ArrowLeft'){e.preventDefault();showPrevious();}
      if(e.key==='ArrowRight'){e.preventDefault();showNext();}
    });
  }
});

/* Dimension navigation and product filtering */
document.addEventListener('DOMContentLoaded',function(){
  const detail=document.querySelector('.dimension-detail-page');
  if(!detail) return;

  const dimension=detail.dataset.dimension || 'relationship';
  const params=new URLSearchParams(window.location.search);
  const selectedParam=decodeURIComponent(params.get('value') || '');
  const selectedAliases={
    'Partners':'Partner',
    'Friends':'Friend',
    'Mentors / Teachers':'Mentor / Teacher',
    'Coworkers':'Coworker'
  };
  const selected=dimension==='relationship' ? (selectedAliases[selectedParam] || selectedParam) : selectedParam;
  const title=detail.querySelector('[data-dimension-title]');
  const eyebrow=detail.querySelector('[data-dimension-eyebrow]');
  const intro=detail.querySelector('[data-dimension-intro]');
  const breadcrumb=detail.querySelector('[data-dimension-breadcrumb]');
  const allLink=detail.querySelector('[data-dimension-all-link]');
  const currentBreadcrumb=detail.querySelector('[data-dimension-current]');
  const filterWrap=detail.querySelector('[data-dimension-filter-wrap]');
  const filterLabel=detail.querySelector('[data-dimension-filter-label]');
  const filter=detail.querySelector('[data-dimension-filter]');
  const items=[...detail.querySelectorAll('.dimension-product-item')];
  const grid=detail.querySelector('[data-products-grid]');
  const empty=detail.querySelector('[data-empty-state]');
  const count=detail.querySelector('.dimension-results-count');
  const typeFilter=detail.querySelector('[data-type-filter]');
  const priceFilter=detail.querySelector('[data-price-filter]');
  const sortFilter=detail.querySelector('[data-sort-filter]');

  const normalize=(value)=>String(value||'')
    .replace(/[’‘]/g,"'")
    .replace(/\s*\/\s*/g,' / ')
    .replace(/\s+/g,' ')
    .trim()
    .toLowerCase();

  const config={
    relationship:{
      eyebrow:'Relationship',
      back:'relationships',
      fallbackTitle:'Choose a relationship',
      fallbackIntro:'The right gift starts with the relationship. Choose who they are, and we’ll help you find something that feels personal.',
      items:{
        'Partner':{intro:'For the person you love and choose every day. A meaningful piece can say thank you for the companionship, support, patience, and little moments you share.',children:['Boyfriend','Girlfriend','Husband','Wife','Fiancé / Fiancée']},
        'Family':{intro:'For the people who have shaped your story and stood beside you. Choose a gift that carries gratitude, care, and a reminder of how much they mean to you.',children:['Mom','Dad','Daughter','Son','Sister','Brother','Grandparent']},
        'Friend':{intro:'For the people who make ordinary days better and important moments easier to remember. Give them something that says you’re glad they’re part of your life.',children:['Best Friend','Childhood Friend','Long-Distance Friend','New Friend']},
        'Mentor / Teacher':{intro:'For someone whose guidance, patience, or example helped you become who you are. A small gift can carry a lasting thank-you.',children:['Mentor','Teacher']},
        'Coworker':{intro:'For the people you work with, learn from, and build alongside. Choose something thoughtful for appreciation, congratulations, or a meaningful transition.',children:['Coworker','Boss / Manager','Client','Business Partner']},
        'Myself':{intro:'For your own story. Mark a milestone, honor how far you’ve come, or simply give yourself a small reminder of what matters.',children:['Myself']}
      }
    },
    meaning:{
      eyebrow:'Meaning',back:'meanings',fallbackTitle:'Choose a meaning',fallbackIntro:'Choose what you want the gift to convey.',items:{
        'Love':'For the people you love and the connections you want to keep close. Choose a piece that quietly carries the feeling of being known, chosen, and remembered.',
        'Friendship':'For the friends who make life better simply by being in it. A small reminder of the bond you share can mean more than a big gesture.',
        'Gratitude':'For a simple, heartfelt thank-you. Give something that lets them know how much their care and presence mean to you.',
        'Encouragement':'For the moments when someone needs to know you believe in them. Let the gift carry a little of your confidence with them.',
        'Well-being':'For wishing someone health, happiness, peace, and a life well lived.',
        'Good Fortune':'For a heartfelt wish for happiness, success, and good things ahead.',
        'Growth':'For becoming, learning, and moving forward. Celebrate the person they are becoming and the journey it took to get there.',
        'Peace & Balance':'For slower moments, steady hearts, and a little more ease and balance in everyday life.',
        'Beauty':'For the joy of beauty, style, and self-expression. Choose a piece simply because you love the way it looks and feels to wear.',
        'Abundance':'For welcoming more joy, possibility, and good things into life.',
        'Protection':'For carrying a little reminder of care, safety, and being watched over.',
        'Hope':'For believing in brighter days and everything still to come.'
      }
    },
    occasion:{
      eyebrow:'Occasion',back:'occasions',fallbackTitle:'Choose an occasion',fallbackIntro:'Choose the moment that brings the gift into the story.',items:{
        'Holidays & Traditions':{intro:'For the dates that come around every year and the traditions that make them feel personal.',children:['Birthday','Anniversary','Valentine’s Day','Mother’s Day','Father’s Day','Christmas','Thanksgiving']},
        'Worth Celebrating':{intro:'For achievements, milestones, and moments that deserve to be celebrated out loud.',children:['Graduation','Promotion','Engagement','Wedding','New Baby','Retirement', "Get Well"]},
        'New Beginnings':{intro:'For the moments when life turns a page — and someone is stepping into what comes next.',children:['New Job','New Home','New Chapter','Starting Over']},
        'Just Because Group':{label:'Just Because',intro:'Not every meaningful gift needs a date. Sometimes the right reason is simply that someone matters to you.',children:['Long Distance','Going Through a Hard Time','Missing Someone','Just Because']},
        'Birthday':'For the day that celebrates who they are and another year of the story you share.',
        'Anniversary':'For the years, memories, and everyday moments that have become part of your story together.',
        'Valentine’s Day':'For saying I love you, in a way they can keep.',
        'Mother’s Day':'For the care, patience, and love that deserve to be remembered.',
        'Father’s Day':'For the guidance, support, and steady presence that helped shape your story.',
        'Christmas':'For a thoughtful reminder of love and connection during the season of giving.',
        'Thanksgiving':'For the people and relationships you are grateful to have in your life.',
        'Graduation':'For celebrating how far they’ve come and everything that comes next.',
        'New Job':'For a new role, a fresh challenge, and the confidence to step into it.',
        'Promotion':'For recognizing the work, growth, and achievement behind a well-earned next step.',
        'Engagement':'For celebrating a promise, a new chapter, and the life they are building together.',
        'Wedding':'For marking the beginning of a shared life and a moment they’ll remember for years.',
        'New Home':'For a new place to call home, and all the memories waiting to be made there.',
        'New Baby':'For welcoming a new little life and celebrating the beginning of a new family chapter.',
        'Retirement':'For honoring years of work and celebrating the freedom to choose what comes next.',
        'Get Well':'For letting someone know you’re thinking of them and wishing them comfort, strength, and a smooth recovery.',
        'New Chapter':'For the moment when one part of life closes and another begins.',
        'Long Distance':'For the people who may be far away, but never far from your thoughts.',
        'Going Through a Hard Time':'For letting someone know they don’t have to carry a difficult season alone.',
        'Starting Over':'For choosing a fresh start and reminding them that new beginnings are possible.',
        'Missing Someone':'For the days when you wish they were closer, and want them to know they’re on your mind.',
        'Just Because':'For no special date at all — just a simple reminder that someone matters to you.'
      }
    }
  };

  const cfg=config[dimension] || config.relationship;
  const itemCfg=cfg.items[selected];
  const label=(itemCfg && itemCfg.label) || (selected==='Myself'?'Myself':(selectedParam || selected)) || cfg.fallbackTitle;
  eyebrow.textContent=cfg.eyebrow;
  title.textContent=selected ? (dimension==='occasion' && selected==='Just Because Group' ? 'For Just Because' : 'For '+label) : cfg.fallbackTitle;
  intro.textContent=(typeof itemCfg==='string' ? itemCfg : itemCfg?.intro) || cfg.fallbackIntro;
  if (breadcrumb && allLink && currentBreadcrumb) {
    allLink.textContent='All '+cfg.back;
    allLink.href='/pages/'+cfg.back;
    currentBreadcrumb.textContent=label;
  }

  const children=typeof itemCfg==='object' && itemCfg ? (itemCfg.children||[]) : [];
  if(children.length){
    filterWrap.style.display='block';
    filterLabel.textContent=dimension==='relationship'?'Filter by recipient': 'Filter by occasion';
    const values=['All',...children];
    values.forEach(value=>{
      const btn=document.createElement('button');
      btn.type='button'; btn.className='dimension-filter-btn'+(value==='All'?' active':'');
      btn.dataset.filterValue=value; btn.textContent=value; filter.appendChild(btn);
    });
  }

  const tagList=(item)=>String(item.dataset.productTags||'').split('|').map(normalize).filter(Boolean);
  const field=(item,key)=>normalize(item.dataset[key]||'');
  const has=(item,value,prefixes=[])=>{
    const v=normalize(value), tags=tagList(item);
    if(!v) return false;
    if(tags.includes(v)) return true;
    return prefixes.some(prefix=>tags.includes(normalize(prefix+value)) || tags.includes(normalize(prefix+': '+value)));
  };

  const occasionGroups={
    'holidays & traditions':['Birthday','Anniversary','Valentine’s Day','Mother’s Day','Father’s Day','Christmas','Thanksgiving'],
    'worth celebrating':['Graduation','Promotion','Engagement','Wedding','New Baby','Retirement','Get Well'],
    'new beginnings':['New Job','New Home','New Chapter','Starting Over'],
    'just because group':['Long Distance','Going Through a Hard Time','Missing Someone','Just Because']
  };

  const matchesPrimary=(item)=>{
    if(!selected) return false;
    if(dimension==='relationship'){ if(selected==='Myself') return field(item,'productRelationship')===normalize('Myself') || field(item,'productRelationship')===normalize('Yourself') || has(item,'Myself',['Relationship','relationship']) || has(item,'Yourself',['Relationship','relationship']); return field(item,'productRelationship')===normalize(selected) || has(item,selected,['Relationship','relationship']); }
    if(dimension==='meaning'){
      const aliases={
        'Love':['Love & Connection'],
        'Friendship':['Friendship & Connection'],
        'Gratitude':['Thank You','Appreciation'],
        'Encouragement':['Encouragement','Strength & Resilience','Strength & Courage'],
        'Well-being':['Health','Wellness','Well-being'],
        'Good Fortune':['Best Wishes','Good Luck'],
        'Growth':['Growth & Transformation'],
        'Peace & Balance':['Balance','Peace & Serenity','Peace & Calm'],
        'Beauty':['Beauty & Self-Expression'],
        'Abundance':['Abundance & Prosperity'],
        'Protection':['Protection & Safety'],
        'Hope':['Hope & Positivity']
      };
      if(field(item,'productMeaning')===normalize(selected) || has(item,selected,['Meaning','meaning'])) return true;
      return (aliases[selected]||[]).some(v=>field(item,'productMeaning')===normalize(v) || has(item,v,['Meaning','meaning']));
    }
    if(dimension==='occasion'){
      const group=occasionGroups[normalize(selected)];
      if(group) return group.some(x=>field(item,'productOccasion')===normalize(x) || has(item,x,['Occasion','occasion']));
      return field(item,'productOccasion')===normalize(selected) || has(item,selected,['Occasion','occasion']);
    }
    return false;
  };

  const matchesSecondary=(item,value)=>{
    if(value==='All') return true;
    if(dimension==='relationship') return field(item,'productRelationshipDetail')===normalize(value) || has(item,value,['Relationship Detail','relationship detail','RelationshipDetail']);
    if(dimension==='occasion') return field(item,'productOccasion')===normalize(value) || has(item,value,['Occasion','occasion']);
    return true;
  };

  const matchesType=(item)=>{
    const value=typeFilter?.value || 'All';
    return value==='All' || normalize(item.dataset.productType)===normalize(value);
  };
  const matchesPrice=(item)=>{
    const value=priceFilter?.value || 'All';
    if(value==='All') return true;
    const price=Number(item.dataset.productPrice||0);
    if(value==='150+') return price>=150;
    const parts=value.split('-').map(Number);
    return price>=parts[0] && price<parts[1];
  };

  const apply=(secondary)=>{
    let visible=0;
    items.forEach(item=>{
      const show=matchesPrimary(item) && matchesSecondary(item,secondary) && matchesType(item) && matchesPrice(item);
      item.classList.toggle('is-hidden',!show);
      if(show) visible++;
    });
    if(empty) empty.style.display=visible?'none':'block';
    if(count) count.textContent=visible+' '+(visible===1?'gift':'gifts');
  };

  filter.querySelectorAll('.dimension-filter-btn').forEach(btn=>btn.addEventListener('click',()=>{
    filter.querySelectorAll('.dimension-filter-btn').forEach(x=>x.classList.remove('active'));
    btn.classList.add('active');
    apply(btn.dataset.filterValue||'All');
  }));

  if(typeFilter){
    const types=[...new Set(items.map(item=>String(item.dataset.productType||'').trim()).filter(Boolean))].sort((a,b)=>a.localeCompare(b));
    types.forEach(value=>{
      const option=document.createElement('option'); option.value=value; option.textContent=value; typeFilter.appendChild(option);
    });
    typeFilter.addEventListener('change',()=>apply(filter.querySelector('.dimension-filter-btn.active')?.dataset.filterValue||'All'));
  }
  if(priceFilter) priceFilter.addEventListener('change',()=>apply(filter.querySelector('.dimension-filter-btn.active')?.dataset.filterValue||'All'));

  const sortItems=(mode)=>{
    const visibleItems=items.filter(item=>!item.classList.contains('is-hidden'));
    const titleOf=(item)=>String(item.querySelector('.product-card-shop h3')?.textContent||'').trim().toLowerCase();
    visibleItems.sort((a,b)=>{
      const pa=Number(a.dataset.productPrice||0), pb=Number(b.dataset.productPrice||0);
      if(mode==='price-ascending') return pa-pb;
      if(mode==='price-descending') return pb-pa;
      if(mode==='title-ascending') return titleOf(a).localeCompare(titleOf(b));
      if(mode==='title-descending') return titleOf(b).localeCompare(titleOf(a));
      return items.indexOf(a)-items.indexOf(b);
    });
    visibleItems.forEach(item=>grid.appendChild(item));
  };
  if(sortFilter) sortFilter.addEventListener('change',()=>sortItems(sortFilter.value));

  apply('All');
  requestAnimationFrame(()=>detail.classList.remove('is-loading'));
});


/* Collection filters + sorting — persistent AJAX controls.
   The filter form stays mounted; only the results area is replaced.
   Event delegation keeps Apply Filters working after every AJAX refresh. */
document.addEventListener('DOMContentLoaded',function(){
  const getForm=()=>document.querySelector('[data-collection-filter-form]');
  const getSort=()=>document.querySelector('[data-collection-sort]');
  const getResults=()=>document.querySelector('.collection-results');

  const buildFilterUrl=()=>{
    const form=getForm();
    const url=new URL(window.location.href);
    if(!form) return url;

    // Remove only filter/sort parameters represented by this form.
    const names=[...form.elements].map(el=>el.name).filter(Boolean);
    [...new Set(names)].forEach(name=>url.searchParams.delete(name));

    const data=new FormData(form);
    let giftType='';
    for(const [key,value] of data.entries()){
      if(value==='' || value==null) continue;
      if(key==='filter.p.product_type'){
        giftType=String(value).trim();
        continue;
      }
      // Shopify storefront price filter URL values are monetary values in the
      // shop's default currency (for example 5 or 20.40), not cents.
      // Liquid's filter.min_value.value is stored in subunits, so we divide
      // only when displaying the input; the submitted UI value must stay as-is.
      if(key==='filter.v.price.gte' || key==='filter.v.price.lte'){
        const dollars=Number(value);
        if(Number.isFinite(dollars)) url.searchParams.append(key,String(dollars));
        continue;
      }
      url.searchParams.append(key,value);
    }

    // Product Type is not always exposed as a configured Storefront filter.
    // When it isn't, use Shopify's native product-type collection route as a
    // reliable fallback. This still allows price/availability filters to be
    // applied to the resulting collection.
    const allPath='/collections/all';
    if(giftType){
      url.pathname='/collections/types';
      url.searchParams.set('q',giftType);
    }else if(url.pathname==='/collections/types'){
      url.pathname=allPath;
      url.searchParams.delete('q');
    }
    return url;
  };

  const refreshResults=async(url)=>{
    const results=getResults();
    if(!results) return;
    results.classList.add('is-loading');

    try{
      const response=await fetch(url.toString(),{
        headers:{'X-Requested-With':'XMLHttpRequest','Accept':'text/html'},
        credentials:'same-origin'
      });
      if(!response.ok) throw new Error('Request failed');

      const html=await response.text();
      const doc=new DOMParser().parseFromString(html,'text/html');
      const nextResults=doc.querySelector('.collection-results');
      if(!nextResults) throw new Error('Results not found');

      // Replace only the right-hand results. The filter form is untouched.
      results.replaceWith(nextResults);
      window.history.pushState({},'',url.toString());
    }catch(error){
      window.location.href=url.toString();
    }
  };

  // Bind once at document level so the handler survives results replacement.
  if(window.__sayoraCollectionFiltersBound) return;
  window.__sayoraCollectionFiltersBound=true;

  document.addEventListener('submit',function(e){
    const form=e.target.closest('[data-collection-filter-form]');
    if(!form) return;

    const minInput=form.querySelector('input[name="filter.v.price.gte"]');
    const maxInput=form.querySelector('input[name="filter.v.price.lte"]');
    const error=form.querySelector('[data-price-filter-error]');
    const min=minInput && minInput.value!=='' ? Number(minInput.value) : null;
    const max=maxInput && maxInput.value!=='' ? Number(maxInput.value) : null;

    if(error){
      error.textContent='';
      error.classList.remove('is-visible');
    }

    if((min!==null && !Number.isFinite(min)) || (max!==null && !Number.isFinite(max)) || (min!==null && min<0) || (max!==null && max<0)){
      e.preventDefault();
      if(error){
        error.textContent='Please enter valid prices.';
        error.classList.add('is-visible');
      }
      return;
    }

    if(min!==null && max!==null && min>max){
      e.preventDefault();
      if(error){
        error.textContent='Minimum price cannot be higher than maximum price.';
        error.classList.add('is-visible');
      }
      if(minInput){minInput.setAttribute('aria-invalid','true');}
      if(maxInput){maxInput.setAttribute('aria-invalid','true');}
      return;
    }

    if(minInput) minInput.removeAttribute('aria-invalid');
    if(maxInput) maxInput.removeAttribute('aria-invalid');
    e.preventDefault();
    refreshResults(buildFilterUrl());
  });

  document.addEventListener('input',function(e){
    const input=e.target.closest('[data-collection-filter-form] input[name="filter.v.price.gte"], [data-collection-filter-form] input[name="filter.v.price.lte"]');
    if(!input) return;
    const form=input.closest('[data-collection-filter-form]');
    const error=form && form.querySelector('[data-price-filter-error]');
    const minInput=form && form.querySelector('input[name="filter.v.price.gte"]');
    const maxInput=form && form.querySelector('input[name="filter.v.price.lte"]');
    const min=minInput && minInput.value!=='' ? Number(minInput.value) : null;
    const max=maxInput && maxInput.value!=='' ? Number(maxInput.value) : null;
    if(min!==null && max!==null && min>max){
      if(error){error.textContent='Minimum price cannot be higher than maximum price.';error.classList.add('is-visible');}
    }else if(error){
      error.textContent='';
      error.classList.remove('is-visible');
      if(minInput) minInput.removeAttribute('aria-invalid');
      if(maxInput) maxInput.removeAttribute('aria-invalid');
    }
  });

  document.addEventListener('change',function(e){
    const availability=e.target.closest('[data-sayora-availability]');
    if(availability){
      e.preventDefault();
      const url=new URL(window.location.href);
      // All current SAYORA catalog products are intentionally untracked, so
      // 'In stock' means the normal collection (remove the native availability
      // filter), while 'Out of stock' uses Shopify's native 0 filter and should
      // return zero products.
      if(availability.dataset.sayoraAvailability==='out-of-stock'){
        url.searchParams.set('filter.v.availability','0');
      }else{
        url.searchParams.delete('filter.v.availability');
      }
      refreshResults(url);
      return;
    }

    const sort=e.target.closest('[data-collection-sort]');
    if(!sort) return;
    e.preventDefault();
    const url=new URL(window.location.href);
    url.searchParams.set('sort_by',sort.value);
    refreshResults(url);
  });

  window.addEventListener('popstate',function(){ window.location.reload(); });
});

/* Header: hide on downward scroll, reliably reveal on upward scroll */
document.addEventListener('DOMContentLoaded', function(){
  const header = document.querySelector('.sayora-header');
  if(!header) return;

  let lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
  let ticking = false;
  const threshold = 4;

  function updateHeader(){
    const y = Math.max(0, window.pageYOffset || document.documentElement.scrollTop || 0);
    const delta = y - lastY;

    if(y <= 12){
      header.classList.remove('is-hidden');
    } else if(Math.abs(delta) >= threshold){
      if(delta > 0){
        header.classList.add('is-hidden');
      } else {
        header.classList.remove('is-hidden');
      }
      lastY = y;
    }
    ticking = false;
  }

  window.addEventListener('scroll', function(){
    if(!ticking){
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }, {passive:true});

  /* Reveal immediately when the pointer reaches the top edge. */
  window.addEventListener('mousemove', function(e){
    if(e.clientY <= 18) header.classList.remove('is-hidden');
  }, {passive:true});
});

/* v5.53 — Product detail refinements */
document.addEventListener('DOMContentLoaded',function(){
  const variantSelect=document.querySelector('[data-product-variant-select]');
  const priceEl=document.querySelector('[data-product-price]');
  if(variantSelect&&priceEl){
    const updatePrice=()=>{
      const option=variantSelect.options[variantSelect.selectedIndex];
      if(option&&option.dataset.price) priceEl.textContent=option.dataset.price;
    };
    variantSelect.addEventListener('change',updatePrice);
    updatePrice();
  }

  /* Older imported descriptions may contain a redundant standard wrist-size line.
     Remove only a standalone block that explicitly carries that label. */
  document.querySelectorAll('.product-description-lead p,.product-description-lead li,.product-description-lead div').forEach(node=>{
    const text=(node.textContent||'').replace(/\s+/g,' ').trim().toLowerCase();
    if(/^standard wrist size\b/.test(text)) node.remove();
  });
});

/* SAYORA mobile navigation: close on scroll, link click, resize, and Escape. */
document.addEventListener('DOMContentLoaded',function(){
  const header=document.querySelector('[data-sayora-header]');
  const toggle=document.querySelector('[data-menu-toggle]');
  const mobileNav=document.querySelector('[data-mobile-nav]');
  if(!header||!toggle||!mobileNav) return;
  const closeMenu=()=>{
    document.body.classList.remove('menu-open');
    toggle.setAttribute('aria-expanded','false');
    mobileNav.setAttribute('aria-hidden','true');
  };
  const openMenu=()=>{
    document.body.classList.add('menu-open');
    toggle.setAttribute('aria-expanded','true');
    mobileNav.setAttribute('aria-hidden','false');
  };
  toggle.addEventListener('click',()=>document.body.classList.contains('menu-open')?closeMenu():openMenu());
  mobileNav.querySelectorAll('a').forEach(a=>a.addEventListener('click',closeMenu));
  document.addEventListener('keydown',e=>{if(e.key==='Escape')closeMenu();});
  let lastScroll=window.scrollY;
  let raf=null;
  window.addEventListener('scroll',()=>{
    if(raf) return;
    raf=requestAnimationFrame(()=>{
      raf=null;
      const y=window.scrollY||0;
      if(document.body.classList.contains('menu-open')&&Math.abs(y-lastScroll)>3) closeMenu();
      lastScroll=y;
    });
  },{passive:true});
  window.addEventListener('resize',()=>{if(window.innerWidth>900)closeMenu();},{passive:true});
});

